<script lang="ts">import SvgIcon from "./SvgIcon.svelte";
</script>

<SvgIcon>
  <svg
    width="29"
    height="28"
    viewBox="0 0 29 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="28.7778" height="28" rx="14" />
    <path
      d="M20.8719 11.5059C20.6281 11.5059 20.3938 11.4122 20.2063 11.2341L15.2 6.22781C14.8344 5.86218 14.8344 5.27156 15.2 4.90593C15.5656 4.54031 16.1563 4.54031 16.5219 4.90593L21.5281 9.91218C21.8938 10.2778 21.8938 10.8684 21.5281 11.2341C21.3594 11.4122 21.1156 11.5059 20.8719 11.5059Z"
      fill="white"
    />
    <path
      d="M15.875 23.375C15.6313 23.375 15.3969 23.2812 15.2094 23.1031C14.8438 22.7375 14.8438 22.1469 15.2094 21.7812L22.0531 14.9375H3.6875C3.17187 14.9375 2.75 14.5156 2.75 14C2.75 13.4844 3.17187 13.0625 3.6875 13.0625H24.3125C24.6875 13.0625 25.0344 13.2875 25.175 13.6437C25.3156 13.9906 25.2406 14.3937 24.9688 14.6656L16.5313 23.1031C16.3625 23.2812 16.1187 23.375 15.875 23.375Z"
      fill="white"
    />
  </svg>
</SvgIcon>
